import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button as MuiButton,
} from "@material-ui/core";
import { AssignmentInd } from "@material-ui/icons";
import { format, parseISO } from "date-fns";
import { forwardRef, useEffect, useState } from "react";
import { useTranslate } from "react-admin";
import { useHistory } from "react-router-dom";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import resourceNames from "../../../../common/data/resourceNames";
import {
  GeometrisWidgetDriverEventDto,
  SafetyDashboardApiFactory,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import {
  useButtonStyles,
  useTableHeaderStyles,
  WidgetProps,
} from "../../../assets/maintenance-dashboard/common";
import { Empty } from "../../../assets/maintenance-dashboard/widgets/Empty";
import { Widget } from "../../../assets/maintenance-dashboard/widgets/Widget";

export const GeometrisAlerts = forwardRef(
  ({ className, icon, title, ...rest }: WidgetProps, ref) => {
    const translate = useTranslate();
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<GeometrisWidgetDriverEventDto[]>();
    const axios = useAxiosInstance();
    const classes = useTableHeaderStyles();
    const buttonClasses = useButtonStyles();
    const history = useHistory();

    useEffect(() => {
      if (!axios) {
        return;
      }

      setLoading(true);
      SafetyDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppSafetydashboardGeometriseventsGet(150)
        .then((result) => {
          setData(result.data);
        })
        .catch((e) => console.error(handleAxiosError(e)))
        .finally(() => setLoading(false));
    }, [axios]);

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}>
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && data.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell className="driverTableCell">Driver</TableCell>
                      <TableCell className="driverTableCell">Alert</TableCell>
                      <TableCell className="timeTableCell">Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((x) => (
                      <TableRow key={x.id}>
                        <TableCell>
                          <MuiButton
                            startIcon={<AssignmentInd />}
                            color="primary"
                            className={buttonClasses.label}
                            onClick={() =>
                              history.push(
                                `/${resourceNames.SAFETY_DASHBOARD}/${x.driverId}`
                              )
                            }>
                            {`${x.driverName!} (${x.driverGivenId})`}
                          </MuiButton>
                        </TableCell>
                        <TableCell>
                          {translate(
                            `resources.admin-notifications.notificationTypes.Vehicle.${x.messageReason}`
                          )}
                        </TableCell>
                        <TableCell>
                          {format(
                            parseISO(x.timestamp!),
                            "MMM do, yyyy hh:mm:ss a"
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <div className="table-wrapper table-wrapper-center">
              <Empty />
            </div>
          )}
        </div>
      </Widget>
    );
  }
);
